import {
  AutoComplete,
  Button, Card, Col,
  ColorPicker,
  DatePicker,
  Form,
  Input, Row,
  Select,
  Table,
} from "antd";
import React, { useEffect, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import ModalAddMember from "./ModalAddMember";
import "./style.scss";
import { useInfoUser } from "../../store/UserStore";
import "../../styles/table.scss";
const { Option } = Select;

const ProjectInformation = ({
  initialValues,
  projectTypeOptions,
  progressStepOptions,
  roleOptions,
  authorityOptions,
  projectManager,
  permissionCurrentUser,
  different,
  renderOrganizations,
  isMobile
}) => {
  const [isModalAddMember, setIsModalAddMember] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [count, setCount] = useState(0);
  const { user, languageMap } = useInfoUser();

  const getDisplayCode = (item, language) => {
    const names = {
      us: item.enName,
      vn: item.vnName,
      lkr: item.krName,
    };

    return names[language] || item.enName;
  };

  const columns = [
    {
      title: languageMap?.["project.management.info.addMember.name"] ?? "Name",
      dataIndex: "name",
      render: (_, record) => (
        <Form.Item
          name={["participantRequest", record.key, "participantCode"]}
          initialValue={record.code}
          noStyle
        >
          {record.name}
        </Form.Item>
      ),
    },
    {
      title: languageMap?.["project.management.info.addMember.role"] ?? "Role",
      dataIndex: "role",
      render: (_, record) => (
        <Form.Item
          name={["participantRequest", record.key, "roleCode"]}
          rules={[
            {
              required: true,
              message:
                languageMap?.["project.management.require.role"] ??
                "Role is require!",
            },
          ]}
          className="flex-1 p-0 m-0 form-input"
        >
          <Select
            placeholder={
              languageMap?.["project.management.info.selectRole"] ??
              "Select role"
            }
            disabled={handlePermissionUser(user)}
          >
            {roleOptions.map((item) => (
              <Option value={item.code} key={item.code}>
                {getDisplayCode(item, user?.language)}
              </Option>
            ))}
          </Select>
        </Form.Item>
      ),
    },
    {
      title:
        languageMap?.["project.management.info.addMember.autho"] ?? "Authority",
      dataIndex: "authority",
      render: (_, record) => (
        <Form.Item
          name={["participantRequest", record.key, "authorityCode"]}
          rules={[
            {
              required: true,
              message:
                languageMap?.["project.management.require.author"] ??
                "Authority is require!",
            },
          ]}
          className="flex-1 p-0 m-0 form-input"
        >
          <Select
            placeholder={
              languageMap?.["project.management.info.selectAuthor"] ??
              "Select authority"
            }
            disabled={handlePermissionUser(user)}
          >
            {authorityOptions.map((item) => (
              <Option value={item.code} key={item.code}>
                {getDisplayCode(item, user?.language)}
              </Option>
            ))}
          </Select>
        </Form.Item>
      ),
    },
    {
      title: "",
      dataIndex: "action",
      width: 80,
      render: (_, record) => (
        <Button
          onClick={() => handleDelete(record.key)}
          type="text"
          disabled={handlePermissionUser(user)}
        >
          <DeleteOutlined className="text-[red]" />
        </Button>
      ),
    },
  ];

  const handleAdd = () => {
    setIsModalAddMember(true);
  };

  const handleDelete = (key) => {
    const newParticipants = participants.filter((item) => item.key !== key);
    setParticipants(newParticipants);
  };

  useEffect(() => {
    if (initialValues.type === "UPDATED") {
      setParticipants(
        initialValues.participantRequest.map((item, index) => {
          return {
            ...item,
            key: index,
          };
        })
      );
      setCount(initialValues.participantRequest.length);
    }
  }, [initialValues]);

  const handlePermissionUser = (user) => {
    const isUpdated = initialValues?.type === "UPDATED";
    const isProjectManager = projectManager?.userCode === user?.userCode;

    if (isUpdated) {
      return !isProjectManager;
    } else {
      return false;
    }
  };

  return (
    <>
      <div className="flex center items-center my-2">
        <span className="pr-2 font-bold">
          {languageMap?.["project.management.info.title"] ??
            "Project Information"}
        </span>
        <Form.Item name="color" noStyle>
          <ColorPicker disabled size="small" />
        </Form.Item>
      </div>
      <div className="my-4 pb-[12px]">
        <div className="project-form-label-manager">
          <div className="project-item-info mb-4 w-full">
            <span className="mr-3 label-form ">
              {languageMap?.["project.management.info.manager"] ??
                "Project Manager:"}
            </span>
            {/*process view project manager name and paths*/}
            <div className="flex flex-1 form-input justify-between items-center border border-gray-300 rounded-md p-1 px-3 bg-[#F5F5F5] ">
              <div className="mr-3">
                <strong className="text-[#B8B8B8] text-[12px]">
                  {projectManager?.name || "UNKNOWN PROJECT MANAGER"}
                </strong>
              </div>
              <div>{renderOrganizations()}</div>
            </div>
            <Form.Item
              name="managerCode"
              className="flex-1 p-0 m-0 form-input "
              hidden
            >
              <AutoComplete className="project-manager" disabled>
                <Input placeholder="Project Manager" maxLength={100} />
              </AutoComplete>
            </Form.Item>
          </div>
        </div>

        <div className="project-item-info mb-4">
          <span className="mr-3 label-form ">
            {languageMap?.["project.management.info.name"] ?? "Project Name:"}
            <span className="text-red-500">{" *"}</span>
          </span>
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message:
                  languageMap?.["project.management.require.name"] ??
                  "Project name is require!",
              },
              {
                max: 100,
                message: "Project name cannot exceed 100 characters!",
              },
            ]}
            className="flex-1 flex-1 p-0 m-0 form-input"
          >
            <Input
              disabled={
                different.type === "UPDATED" &&
                !permissionCurrentUser?.includes("U")
              }
              className="form-input"
              placeholder={
                languageMap?.["project.management.info.name"] ?? "Project Name"
              }
              maxLength={100}
            />
          </Form.Item>
        </div>

        <div>
          <div className="project-form">
            <div className="project-item-info form-item-container">
              <span className="mr-3 label-form ">
                {languageMap?.["project.management.info.type"] ??
                  "Project Type:"}
                <span className="text-red-500">{" *"}</span>
              </span>
              <Form.Item
                name="segmentCode"
                rules={[
                  {
                    required: true,
                    message:
                      languageMap?.["project.management.require.type"] ??
                      "Please select project type!",
                  },
                ]}
                className="flex-1 p-0 m-0 form-input"
              >
                <Select
                  disabled={
                    different.type === "UPDATED" &&
                    !permissionCurrentUser?.includes("U")
                  }
                  placeholder={
                    languageMap?.["project.management.info.type"] ??
                    "Select project type"
                  }
                  className="form-select"
                >
                  {projectTypeOptions.map((item) => (
                    <Option value={item.code} key={item.code}>
                      {languageMap?.[
                        `project.management.info.type.${item.enName.toLowerCase().replace(" ", "_")}`
                      ] ?? item.enName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="project-item-info form-item-container">
              <span className="mr-3 label-form ">
                {languageMap?.["project.management.info.step"] ??
                  "Progress Step:"}
                <span className="text-red-500">{" *"}</span>
              </span>
              <Form.Item
                name="progressStepCode"
                label=""
                rules={[
                  {
                    required: true,
                    message:
                      languageMap?.["project.management.require.step"] ??
                      "Please select progress step!",
                  },
                ]}
                className="flex-1 p-0 m-0 form-input"
              >
                <Select
                  disabled={
                    different.type === "UPDATED" &&
                    !permissionCurrentUser?.includes("U")
                  }
                  placeholder={
                    languageMap?.["project.management.info.step"] ??
                    "Select progress step"
                  }
                  className="form-select"
                >
                  {progressStepOptions.map((item) => (
                    <Option value={item.code} key={item.code}>
                      {languageMap?.[
                        `project.management.info.step.${item.enName.toLowerCase().replace(" ", "_")}`
                      ] ?? item.enName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>

          <div className="project-form">
            <div className="project-item-info form-item-container flex">
              <span className="mr-3 label-form ">
                {languageMap?.["project.management.info.startDate"] ??
                  "Start Date:"}
              </span>
              <Form.Item name="startDate" className="flex-1 p-0 m-0 form-input">
                <DatePicker
                  disabled={
                    different.type === "UPDATED" &&
                    !permissionCurrentUser?.includes("U")
                  }
                  className="form-select w-full"
                  placeholder={
                    languageMap?.["project.management.info.selectDate"] ??
                    "Select date"
                  }
                />
              </Form.Item>
            </div>
            <div className="project-item-info form-item-container">
              <span className="mr-3 label-form ">
                {languageMap?.["project.management.info.endDate"] ??
                  "End Date:"}
              </span>
              <Form.Item name="endDate" className="flex-1 p-0 m-0 form-input">
                <DatePicker
                  disabled={
                    different.type === "UPDATED" &&
                    !permissionCurrentUser?.includes("U")
                  }
                  className="form-select w-full"
                  placeholder={
                    languageMap?.["project.management.info.selectDate"] ??
                    "Select date"
                  }
                />
              </Form.Item>
            </div>
          </div>

          <div className="project-form">
            <div className="project-item-info form-item-container">
              <span className="mr-3 label-form ">
                {languageMap?.["project.management.info.actualStartDate"] ??
                  "Actual Start Date:"}
              </span>
              <Form.Item
                name="actualStartDate"
                className="flex-1 p-0 m-0 form-input"
              >
                <DatePicker
                  disabled={
                    different.type === "UPDATED" &&
                    !permissionCurrentUser?.includes("U")
                  }
                  className="form-select w-full"
                  placeholder={
                    languageMap?.["project.management.info.selectDate"] ??
                    "Select date"
                  }
                />
              </Form.Item>
            </div>
            <div className="project-item-info form-item-container">
              <span className="mr-3 label-form ">
                {languageMap?.["project.management.info.actualEndDate"] ??
                  "Actual End Date:"}
              </span>
              <Form.Item
                name="actualEndDate"
                className="flex-1 p-0 m-0 form-input"
              >
                <DatePicker
                  disabled={
                    different.type === "UPDATED" &&
                    !permissionCurrentUser?.includes("U")
                  }
                  className="form-select w-full"
                  placeholder={
                    languageMap?.["project.management.info.selectDate"] ??
                    "Select date"
                  }
                />
              </Form.Item>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="flex justify-end pb-4">
          <Button
            type="primary"
            onClick={handleAdd}
            disabled={handlePermissionUser(user)}
          >
            {languageMap?.["project.management.info.addMember"] ??
              "Add Member +"}
          </Button>
        </div>
        <div style={{ marginTop: isMobile ? "20px" : "", paddingBottom: isMobile ? "50px" : "0"  }}>
          {isMobile ? (
              <Row gutter={[16, 16]}>
                {participants?.map((member) => (
                    <Col key={member.key} xs={24}>
                      <Card
                          title={member.name}
                          bordered={false}
                          className="shadow-md rounded"
                          style={{ border: `1px solid #ccc` }}
                          extra={
                            <Button
                                onClick={() => handleDelete(member.key)}
                                type="text"
                                disabled={handlePermissionUser(user)}
                            >
                              <DeleteOutlined className="text-[red]" />
                            </Button>
                          }
                      >
                        <div className="p-[10px]">
                          <Form.Item
                              name={["participantRequest", member.key, "participantCode"]}
                              initialValue={member.code}
                              hidden
                          >
                            <Input />
                          </Form.Item>
                          <div className="font-bold mb-1">
                            {languageMap?.["project.management.info.addMember.role"] ?? "Role"}
                          </div>
                          <Form.Item
                              name={["participantRequest", member.key, "roleCode"]}
                              rules={[
                                {
                                  required: true,
                                  message:
                                      languageMap?.["project.management.require.role"] ??
                                      "Role is require!",
                                },
                              ]}
                              className="w-full mb-3"
                          >
                              <Select
                                  placeholder={
                                    languageMap?.["project.management.info.selectRole"] ??
                                    "Select role"
                                  }
                                  disabled={handlePermissionUser(user)}
                                  className="w-full"
                              >
                                {roleOptions.map((item) => (
                                    <Option value={item.code} key={item.code}>
                                      {getDisplayCode(item, user?.language)}
                                    </Option>
                                ))}
                              </Select>
                          </Form.Item>


                          <div className="font-bold my-1">
                              {languageMap?.["project.management.info.addMember.autho"] ?? "Authority"}
                          </div>
                          <Form.Item
                              name={["participantRequest", member.key, "authorityCode"]}
                              rules={[
                                {
                                  required: true,
                                  message:
                                      languageMap?.["project.management.require.author"] ??
                                      "Authority is require!",
                                },
                              ]}
                              className="w-full"
                          >
                              <Select
                                  placeholder={
                                    languageMap?.["project.management.info.selectAuthor"] ??
                                    "Select authority"
                                  }
                                  disabled={handlePermissionUser(user)}
                                  className="w-full"
                              >
                                {authorityOptions.map((item) => (
                                    <Option value={item.code} key={item.code}>
                                      {getDisplayCode(item, user?.language)}
                                    </Option>
                                ))}
                              </Select>
                          </Form.Item>
                        </div>
                      </Card>
                    </Col>
                ))}
              </Row>
          ) : (
              <Table
                  className="custom-table-scroll"
                  columns={columns}
                  dataSource={participants}
                  pagination={false}
                  scroll={{
                    x: 550,
                    y: 180,
                  }}
                  style={{ height: 240 }}
              />
          )}
        </div>
      </div>

      {isModalAddMember && (
        <ModalAddMember
          isModalOpen={isModalAddMember}
          setIsModalOpen={setIsModalAddMember}
          count={count}
          setCount={setCount}
          participants={participants}
          setParticipants={setParticipants}
          projectManager={projectManager}
        />
      )}
    </>
  );
};

export { ProjectInformation };
